import { Observable } from 'rxjs'
import { OrgBrowserView } from '../models/org-browser-view'

export abstract class OrganizationDataGateway {
    abstract getOrganization(orgId: number): Observable<OrgBrowserView>
    abstract getOrganizationsForParent(parentOrgId: number): Observable<OrgBrowserView[]>
    abstract getPWOrganization(pwEntityId: number, orgId: number): Observable<OrgBrowserView>
    abstract getPWOrganizationsForParent(parentPWEntityId: number, basePWEntityId: number): Observable<OrgBrowserView[]>
    abstract getPWOrganizationsForParentAll(parentPWEntityId: number, basePWEntityId): Observable<OrgBrowserView[]>
    abstract searchOrganization(keyWord: string): Observable<OrgBrowserView[]>
}
